import { DownloadIcon } from 'lucide-react';
import { ColumnDef } from '@tanstack/react-table';
import type { InventoryImport as ListEntry } from 'contracts/inventory-2/uploads';
import { Button } from 'components/ui/ButtonGs';
import { DataTableHelper, Formatter } from 'utils';

import { getStatusName, getTypeName, toSourceFileHref } from '../utils';

const dt = new DataTableHelper<ListEntry>({
  enableHiding: false,
  enableSorting: false,
});

export const useInventoryImportColumns = (): ColumnDef<ListEntry>[] => {
  const type = dt.buildColumn({
    id: 'Tipo',
    accessorKey: 'type',
    content: (row) => getTypeName(row.type),
  });
  const user = dt.buildColumn({
    id: 'Usuário',
    accessorKey: 'user',
    content: (row) => row.user ? `${row.user.name} (${row.user.id})` : '--',
  });
  const startedAt = dt.buildColumn({
    id: 'Iniciado em',
    accessorKey: 'startedAt',
    content: (row) => row.startedAt
      ? Formatter.dateFull(row.startedAt)
      : '--',
  });
  const finishedAt = dt.buildColumn({
    id: 'Finalizado em',
    accessorKey: 'finishedAt',
    content: (row) => row.finishedAt
      ? Formatter.dateFull(row.finishedAt)
      : '--',
  });
  const status = dt.buildColumn({
    id: 'Status',
    accessorKey: 'status',
    content: (row) => getStatusName(row.status),
  });
  const errorMessage = dt.buildColumn({
    id: 'Motivo',
    accessorKey: 'errorMessage',
    content: (row) => row.status === 'failed' && row.errorMessage
      ? row.errorMessage
      : '--',
  });
  const sourceFile = dt.buildColumn({
    id: 'download-button',
    title: '',
    content: (row) => {
      if (!row.fileUrl) return null;

      return (
        <div className={'flex justify-end'}>
          <Button.Root
            size={'xs'}
            variant={'primary'}
            className={'pl-2 justify-start'}
            onClick={() => window.open(toSourceFileHref(row.fileUrl as string), '_blank', 'noopener,noreferrer')}
          >
            Arquivo de origem
            <Button.Icon>
              <DownloadIcon className={'w-4 h-4 !fill-current'} />
            </Button.Icon>
          </Button.Root>
        </div>
      );
    },
  });

  return [
    type,
    user,
    startedAt,
    finishedAt,
    status,
    errorMessage,
    sourceFile,
  ];
};
